// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tX xm","ribbon":"tY xv","title":"tZ xo","seasons":"t0 xt","genres":"t1 xu","buttonWrapper":"t2 xq","button":"t3 xr"};